

export const nextstepreducer=(state={step:{next:`1`}},action)=> {
    switch (action.type) {
        case `NEXT_STEP`:
            return {...state,step:action.payload}
    
        default:return state
    } 
}


export const nextstepaction=(nextstep)=> {
    return {
        type:`NEXT_STEP`,
        payload:nextstep
    }
}

